import { ISiteAdminBridgeSettings } from '../../../settings/types/ISiteSettingsForSiteAdmin';
import { Request } from './Request';

export interface IUpdateSiteBridgeSettingsForSiteAdminParams {
  id: string;
  siteAdminBridgeSettings: ISiteAdminBridgeSettings;
}

export interface IUpdateSiteBridgeSettingsForSiteAdminResult {
}

export class UpdateSiteBridgeSettingsForSiteAdminRequest extends Request<IUpdateSiteBridgeSettingsForSiteAdminParams, IUpdateSiteBridgeSettingsForSiteAdminResult> {
  constructor(params: IUpdateSiteBridgeSettingsForSiteAdminParams) {
    super('updateSiteBridgeSettingsForSiteAdmin', params);
  }
}
